<ng-container *ngIf="!waiting">
  <!-- Estilo plano (Online › Precios): mismo control que los filtros de la barra -->
  <!-- mat-menu da la navegación con teclado (flechas, Escape) y devuelve el foco al control al cerrar -->
  <ng-container *ngIf="flat; else materialSelect">
    <button
      mhFilterTrigger
      type="button"
      [filterOpen]="currencyTrigger.menuOpen"
      [matMenuTriggerFor]="currencyMenu"
      #currencyTrigger="matMenuTrigger"
      [attr.aria-label]="'shared.filters.currency.button' | translate: { currency: (selected | uppercase) }"
    >
      <!-- En móvil el control es un círculo con solo el ícono -->
      <i class="fas fa-dollar-sign tw-text-neutral-500 md:tw-hidden"></i>
      <span class="tw-hidden tw-max-w-64 tw-truncate md:tw-block">
        {{ 'shared.filters.currency.button' | translate: { currency: (selected | uppercase) } }}
      </span>
      <i class="fal fa-angle-down tw-hidden tw-text-base tw-ml-1 tw-text-neutral-400 md:tw-inline"></i>
    </button>

    <mat-menu #currencyMenu="matMenu">
      <button
        mat-menu-item
        *ngFor="let money of currencies"
        role="menuitemradio"
        [attr.aria-checked]="money.code === selected"
        class="!tw-min-h-9 !tw-text-[13px] [&_span]:!tw-font-rubik"
        [ngClass]="money.code === selected ? '!tw-text-main-blue' : '!tw-text-neutral-800'"
        (click)="setCurrency(money)"
      >
        {{ money.code | uppercase }}
      </button>
    </mat-menu>
  </ng-container>

  <ng-template #materialSelect>
    <mat-form-field>
      <mat-select [placeholder]="('shared.filters.currency.select_your_money' | translate )" [(value)]="selected">
        <mat-option *ngFor="let money of currencies" [value]="money.code" (click)="setCurrency(money)">{{money.code | uppercase}}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>
</ng-container>
